import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  videoModalRoot: {
    zIndex: 1400,
  },
  videoModalPaper: {
    borderRadius: 16,
    maxWidth: 'calc(100% - 64px)',
    margin: 32,
    overflow: 'visible',
    boxSizing: 'border-box',
  },
  videoModalPaperSized: {
    width: 606,
  },
  videoModalPaperForm: {
    maxHeight: 'none',
  },
  videoModalContent: {
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    overflow: 'visible',
    flex: '0 0 auto',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    '&:first-child': {
      paddingTop: 24,
    },
  },
  videoModalStep: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
    minWidth: 0,
    alignSelf: 'stretch',
  },
  videoModalHeader: {
    display: 'flex',
    gap: 24,
    alignItems: 'center',
    width: '100%',
  },
  videoModalTitle: {
    flex: 1,
    fontFamily: 'Open Sans',
    fontSize: 20,
    fontWeight: 600,
    color: '#000B33',
    letterSpacing: '0.4px',
    lineHeight: 1.4,
  },
  videoModalCloseBtn: {
    background: '#FA1F31',
    width: 32,
    height: 32,
    padding: 8,
    flexShrink: 0,
    '&:hover': {
      background: '#E01C2D',
    },
    color: '#FFFFFF',
  },
  videoModalCloseIcon: {
    width: 14,
    height: 14,
  },
  videoModalSubtitle: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 400,
    color: '#383838',
    lineHeight: 'normal',
  },
  videoModalCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  videoModalCard: {
    display: 'flex',
    gap: 20,
    alignItems: 'center',
    padding: 16,
    border: '1px solid #D8D8D8',
    borderRadius: 8,
    width: '100%',
    cursor: 'pointer',
    background: '#FFFFFF',
    textAlign: 'left',
    '&:hover': {
      background: '#FAFAFA',
    },
  },
  videoModalCardIconBlue: {
    background: 'rgba(22, 93, 252, 0.2)',
    borderRadius: 48,
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  videoModalCardIconPurple: {
    background: 'rgba(153, 15, 250, 0.2)',
    borderRadius: 48,
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  videoModalCardIconLink: {
    width: 24,
    height: 24,
    display: 'block',
    '& path': {
      fill: '#165DFC',
    },
  },
  videoModalCardIconUpload: {
    width: 24,
    height: 24,
    display: 'block',
    '& path': {
      fill: '#990FFA',
    },
  },
  videoModalCardTexts: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    flex: 1,
    minWidth: 0,
  },
  videoModalCardTitle: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#383838',
    lineHeight: 'normal',
  },
  videoModalCardDesc: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 400,
    color: '#383838',
    lineHeight: 'normal',
  },
  videoModalFieldLabel: {
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    color: '#383838',
    marginBottom: 8,
  },
  videoModalInput: {
    width: '100%',
    '& div fieldset': {
      borderColor: '#D8D8D8',
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: 8,
    },
  },
  youtubePreviewBox: {
    width: '100%',
    backgroundColor: '#F4F4F4',
    borderRadius: 8,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    boxSizing: 'border-box',
  },
  youtubePreviewTitle: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#383838',
    letterSpacing: '0.32px',
    lineHeight: 1.4,
  },
  youtubePreviewPlayer: {
    width: '100%',
    borderRadius: 13,
    overflow: 'hidden',
    '& > div': {
      borderRadius: 13,
    },
    '& iframe': {
      borderRadius: '13px !important',
    },
  },
  videoModalForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
    minWidth: 0,
    alignSelf: 'stretch',
    boxSizing: 'border-box',
  },
  videoModalCheckboxes: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'flex-start',
  },
  videoModalCheckboxRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    margin: 0,
    cursor: 'pointer',
  },
  videoModalCheckbox: {
    padding: 0,
    margin: 0,
    width: 24,
    height: 24,
    flexShrink: 0,
    color: '#000A8C',
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
    },
  },
  videoModalCheckboxLabel: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 400,
    color: '#383838',
    lineHeight: 1.5,
    letterSpacing: '-0.16px',
    margin: 0,
    paddingTop: 2,
  },
  videoUploadZoneWrap: {
    width: '100%',
    minWidth: 0,
    alignSelf: 'stretch',
    boxSizing: 'border-box',
  },
  videoUploadZone: {
    border: '1px solid #D8D8D8',
    borderRadius: 8,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    minHeight: 150,
    boxSizing: 'border-box',
    cursor: 'pointer',
    outline: 'none',
    backgroundColor: '#FFFFFF',
  },
  videoUploadZoneDisabled: {
    cursor: 'default',
    opacity: 0.75,
  },
  videoUploadZoneIconWrap: {
    background: 'rgba(153, 15, 250, 0.2)',
    borderRadius: 48,
    padding: 12,
    display: 'flex',
  },
  videoUploadZoneTitle: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#383838',
    textAlign: 'center',
    width: '100%',
    maxWidth: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },
  videoUploadZoneHint: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 400,
    color: '#383838',
    textAlign: 'center',
  },
  videoUploadZoneTexts: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
  },
  videoUploadProgressWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 12,
    width: '100%',
  },
  videoUploadProgress: {
    height: 8,
    borderRadius: 8,
    backgroundColor: '#EAE9EA',
    '& .MuiLinearProgress-bar': {
      borderRadius: 8,
      backgroundColor: '#000A8C',
    },
  },
  videoUploadProgressText: {
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 400,
    color: '#383838',
  },
  videoUploadPreviewBox: {
    width: '100%',
    backgroundColor: '#F4F4F4',
    borderRadius: 8,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    boxSizing: 'border-box',
  },
  videoUploadPreviewHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
    width: '100%',
  },
  videoUploadPreviewTitle: {
    flex: 1,
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#383838',
    letterSpacing: '0.32px',
    lineHeight: 1.4,
  },
  videoUploadDeleteBtn: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#FA1F31',
    letterSpacing: '0.32px',
    lineHeight: 1.4,
  },
  videoUploadPreviewPlayer: {
    width: '100%',
    aspectRatio: '500 / 281',
    borderRadius: 13,
    backgroundColor: '#EAE9EA',
    display: 'block',
    objectFit: 'cover',
  },
  videoModalActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    alignSelf: 'stretch',
  },
  videoModalValidateBtn: {
    width: '100%',
    height: 40,
    borderRadius: 4,
    backgroundColor: '#000A8C',
    color: '#FFFFFF',
    textTransform: 'none',
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: '0.28px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#000070',
    },
    '&:disabled': {
      backgroundColor: 'rgba(0, 10, 140, 0.4)',
      color: '#FFFFFF',
    },
  },
  videoModalBackBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    padding: 0,
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#000A8C',
    letterSpacing: '0.32px',
    lineHeight: 1.4,
  },
  videoModalBackIcon: {
    fontSize: 24,
    color: '#000A8C',
  },
  videoUploadError: {
    color: '#FA1F31',
    fontSize: 14,
    width: '100%',
  },
  videoModalValidateSpinner: {
    color: '#FFFFFF',
  },
}));
